export interface AppLanguageDefinition {
  code: string;
  locale: string;
  englishName: string;
  nativeName: string;
  flag: string;
  translateTarget: string;
  selectorKey?: string;
}

export const APP_LANGUAGE_DEFINITIONS = [
  { code: 'en', locale: 'en-US', englishName: 'English', nativeName: 'English', flag: '🇺🇸', translateTarget: 'en', selectorKey: 'language.selector.english' },
  { code: 'it', locale: 'it-IT', englishName: 'Italian', nativeName: 'Italiano', flag: '🇮🇹', translateTarget: 'it', selectorKey: 'language.selector.italian' },
  { code: 'ua', locale: 'uk-UA', englishName: 'Ukrainian', nativeName: 'Українська', flag: '🇺🇦', translateTarget: 'uk', selectorKey: 'language.selector.ukrainian' },
  { code: 'bg', locale: 'bg-BG', englishName: 'Bulgarian', nativeName: 'Български', flag: '🇧🇬', translateTarget: 'bg' },
  { code: 'hr', locale: 'hr-HR', englishName: 'Croatian', nativeName: 'Hrvatski', flag: '🇭🇷', translateTarget: 'hr' },
  { code: 'cs', locale: 'cs-CZ', englishName: 'Czech', nativeName: 'Čeština', flag: '🇨🇿', translateTarget: 'cs' },
  { code: 'da', locale: 'da-DK', englishName: 'Danish', nativeName: 'Dansk', flag: '🇩🇰', translateTarget: 'da' },
  { code: 'nl', locale: 'nl-NL', englishName: 'Dutch', nativeName: 'Nederlands', flag: '🇳🇱', translateTarget: 'nl' },
  { code: 'et', locale: 'et-EE', englishName: 'Estonian', nativeName: 'Eesti', flag: '🇪🇪', translateTarget: 'et' },
  { code: 'fi', locale: 'fi-FI', englishName: 'Finnish', nativeName: 'Suomi', flag: '🇫🇮', translateTarget: 'fi' },
  { code: 'fr', locale: 'fr-FR', englishName: 'French', nativeName: 'Français', flag: '🇫🇷', translateTarget: 'fr' },
  { code: 'de', locale: 'de-DE', englishName: 'German', nativeName: 'Deutsch', flag: '🇩🇪', translateTarget: 'de' },
  { code: 'el', locale: 'el-GR', englishName: 'Greek', nativeName: 'Ελληνικά', flag: '🇬🇷', translateTarget: 'el' },
  { code: 'hu', locale: 'hu-HU', englishName: 'Hungarian', nativeName: 'Magyar', flag: '🇭🇺', translateTarget: 'hu' },
  { code: 'ga', locale: 'ga-IE', englishName: 'Irish', nativeName: 'Gaeilge', flag: '🇮🇪', translateTarget: 'ga' },
  { code: 'lv', locale: 'lv-LV', englishName: 'Latvian', nativeName: 'Latviešu', flag: '🇱🇻', translateTarget: 'lv' },
  { code: 'lt', locale: 'lt-LT', englishName: 'Lithuanian', nativeName: 'Lietuvių', flag: '🇱🇹', translateTarget: 'lt' },
  { code: 'mt', locale: 'mt-MT', englishName: 'Maltese', nativeName: 'Malti', flag: '🇲🇹', translateTarget: 'mt' },
  { code: 'pl', locale: 'pl-PL', englishName: 'Polish', nativeName: 'Polski', flag: '🇵🇱', translateTarget: 'pl' },
  { code: 'pt', locale: 'pt-PT', englishName: 'Portuguese', nativeName: 'Português', flag: '🇵🇹', translateTarget: 'pt' },
  { code: 'ro', locale: 'ro-RO', englishName: 'Romanian', nativeName: 'Română', flag: '🇷🇴', translateTarget: 'ro' },
  { code: 'sk', locale: 'sk-SK', englishName: 'Slovak', nativeName: 'Slovenčina', flag: '🇸🇰', translateTarget: 'sk' },
  { code: 'sl', locale: 'sl-SI', englishName: 'Slovenian', nativeName: 'Slovenščina', flag: '🇸🇮', translateTarget: 'sl' },
  { code: 'es', locale: 'es-ES', englishName: 'Spanish', nativeName: 'Español', flag: '🇪🇸', translateTarget: 'es' },
  { code: 'sv', locale: 'sv-SE', englishName: 'Swedish', nativeName: 'Svenska', flag: '🇸🇪', translateTarget: 'sv' },
  { code: 'sq', locale: 'sq-AL', englishName: 'Albanian', nativeName: 'Shqip', flag: '🇦🇱', translateTarget: 'sq' },
  { code: 'bs', locale: 'bs-BA', englishName: 'Bosnian', nativeName: 'Bosanski', flag: '🇧🇦', translateTarget: 'bs' },
  { code: 'is', locale: 'is-IS', englishName: 'Icelandic', nativeName: 'Íslenska', flag: '🇮🇸', translateTarget: 'is' },
  { code: 'mk', locale: 'mk-MK', englishName: 'Macedonian', nativeName: 'Македонски', flag: '🇲🇰', translateTarget: 'mk' },
  { code: 'no', locale: 'no-NO', englishName: 'Norwegian', nativeName: 'Norsk', flag: '🇳🇴', translateTarget: 'no' },
  { code: 'ru', locale: 'ru-RU', englishName: 'Russian', nativeName: 'Русский', flag: '🇷🇺', translateTarget: 'ru' },
  { code: 'sr', locale: 'sr-RS', englishName: 'Serbian', nativeName: 'Српски', flag: '🇷🇸', translateTarget: 'sr' },
  { code: 'tr', locale: 'tr-TR', englishName: 'Turkish', nativeName: 'Türkçe', flag: '🇹🇷', translateTarget: 'tr' },
  { code: 'be', locale: 'be-BY', englishName: 'Belarusian', nativeName: 'Беларуская', flag: '🇧🇾', translateTarget: 'be' },
  { code: 'hy', locale: 'hy-AM', englishName: 'Armenian', nativeName: 'Հայերեն', flag: '🇦🇲', translateTarget: 'hy' },
  { code: 'ka', locale: 'ka-GE', englishName: 'Georgian', nativeName: 'ქართული', flag: '🇬🇪', translateTarget: 'ka' },
  { code: 'cy', locale: 'cy-GB', englishName: 'Welsh', nativeName: 'Cymraeg', flag: '🏴', translateTarget: 'cy' },
] as const satisfies readonly AppLanguageDefinition[];

export type LanguageCode = (typeof APP_LANGUAGE_DEFINITIONS)[number]['code'];

export const DEFAULT_LANGUAGE: LanguageCode = 'it';

export const APP_LANGUAGE_CODES = APP_LANGUAGE_DEFINITIONS.map((language) => language.code) as LanguageCode[];

const APP_LANGUAGE_SET = new Set<string>(APP_LANGUAGE_CODES);

export function isLanguageCode(value: string): value is LanguageCode {
  return APP_LANGUAGE_SET.has(value);
}

export function getLanguageDefinition(code: string): AppLanguageDefinition | undefined {
  return APP_LANGUAGE_DEFINITIONS.find((language) => language.code === code);
}

export function getLanguageDisplayName(code: string): string {
  const language = getLanguageDefinition(code);
  return language ? language.nativeName : code.toUpperCase();
}

export function getLanguageFlag(code: string): string {
  const language = getLanguageDefinition(code);
  return language ? language.flag : '🌐';
}

export const LANDING_SUPPORTED_LANGUAGE_CODES: LanguageCode[] = ['en', 'it', 'ua', 'de', 'fr', 'es', 'sk', 'cs', 'pl'];
